import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CustomCheckbox from '@components/Schedules/components/CustomCheckbox';

const useStyles = makeStyles(() => ({
  Container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
  },
  Label: {
    color: '#fdfdfe',
    fontSize: '16px',
    lineHeight: '1',
    fontWeight: 'normal',
    wordWrap: 'break-word',
    minWidth: 0,
    padding: 0,
  },
  pickerValue: {
    color: '#fdfdfe',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF1A',
    padding: '6px 8px',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: '#FFFFFF1A',
      color: '#fdfdfe',
    },
  },
  styledPickerWrapper: {
    backgroundColor: '#ACACAC1A',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    '& .picker-item': {
      transition: 'all 0.3s ease',
      transform: 'scale(0.8) rotateX(20deg)',
      transformOrigin: 'center',
      fontSize: '16px',
      fontWeight: 500,
      fontFamily: 'Roboto',
      color: '#FFFFFF99',
    },
    '& .picker-item.picker-item-selected': {
      transform: 'scale(1) rotateX(0deg)',
      opacity: 1,
      color: 'white !important',
    },
    '& .picker-highlight': {
      backgroundColor: '#FFFFFF2E',
      width: '315px',
      margin: '0 auto',
      left: 'auto',
      right: 'auto',
      borderRadius: '6px',
      '&::before': {
        display: 'none !important',
      },
      '&::after': {
        display: 'none !important',
      },
    },
  },
  TopRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '43px',
  },
  LeftSection: {
    display: 'flex',
    alignItems: 'center',
  },
  RightSection: {
    display: 'flex',
    alignItems: 'center',
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '10px',
  },
  checkbox: {
    marginRight: '12px',
  }
}));

export const Container = (props) => {
  const classes = useStyles();
  return <Box className={classes.Container} {...props} />;
};

export const Label = ({ isActive = true, ...props }) => {
  const classes = useStyles();
  return (
    <Typography
      className={classes.Label}
      style={{ opacity: isActive ? 1 : 0.7 }}
      {...props}
    />
  );
};

export const PickerValue = (props) => {
  const classes = useStyles();
  return <div className={classes.pickerValue} {...props} />;
};

const StyledPickerWrapperBase = React.forwardRef((props, ref) => {
  const classes = useStyles();
  return <Box ref={ref} className={classes.styledPickerWrapper} {...props} />;
});
StyledPickerWrapperBase.displayName = 'StyledPickerWrapper';
export const StyledPickerWrapper = StyledPickerWrapperBase;

export const TopRow = (props) => {
  const classes = useStyles();
  return <Box className={classes.TopRow} {...props} />;
};

export const LeftSection = (props) => {
  const classes = useStyles();
  return <Box className={classes.LeftSection} {...props} />;
};

export const RightSection = (props) => {
  const classes = useStyles();
  return <Box className={classes.RightSection} {...props} />;
};

export const ActionContainer = (props) => {
  const classes = useStyles();
  return <Box className={classes.actionContainer} {...props} />;
};

export const Checkbox = (props) => {
  const classes = useStyles();
  return <CustomCheckbox className={classes.checkbox} {...props} />;
};
